(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/tracking.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/tracking.js');
"use strict";

const trackEvent = svs.components.analytics.trackEvent;
setGlobal('svs.lyckoplatsen.page_result', {
  trackClickPlayResult: () => {
    trackEvent({
      category: "Lyckoplatsen",
      action: 'Rättning',
      opt_label: 'Spela på din Lyckoplats'
    });
  }
});

 })(window);